
import { Alert, Snackbar, Typography } from '@mui/material';
import { theme } from '../../theme';

interface MessagesSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  duration: number | null;
  verticalPosition?: 'top' | 'bottom';
  horizontalPosition?: 'left' | 'center' | 'right';
  ignoreClickaway?: boolean;
}

const MessagesSnackbar: React.FC<MessagesSnackbarProps> = ({ open, onClose, message, severity, duration, verticalPosition = 'bottom', horizontalPosition = 'right', ignoreClickaway = false }) => {
  // Custom onClose handler to ignore clickaway if requested
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (ignoreClickaway && reason === 'clickaway') return;
    onClose();
  };
  return (
    <Snackbar
      onClose={ignoreClickaway ? handleClose : onClose}
      anchorOrigin={{ vertical: verticalPosition, horizontal: horizontalPosition }}
      open={open}
      autoHideDuration={duration}
    >
      <Alert onClose={onClose}
        severity={severity}
        variant="outlined"
        sx={{
          width: '100%',
          backgroundColor: 'white',
          border: '1px solid',
          boxShadow: '0 1px 2px 1px #1018280D',
          borderRadius: '12px',
          borderColor: theme.palette.custom.gray[300],
        }}>
        <Typography variant='textSM'
          fontWeight={600}>
          {message}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default MessagesSnackbar;